import { pipe } from 'fp-ts/function';
import { array, string } from 'fp-ts';
import { TagList } from '@mews-commander/ui';
import { Container } from '@optimus-web/core';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { RoutingRuleListTableRowData } from '../types';

interface ServicesCellProps {
    services: RoutingRuleListTableRowData['services'];
}

export const ServicesCell: React.FC<ServicesCellProps> = ({ services }) => {
    const granularRoutingRulesConditionsExtensionEnabled = useFeatureFlag(
        FeatureFlag.granularRoutingRulesConditionsExtensionEnabled
    );

    return (
        <Container maxHeight={granularRoutingRulesConditionsExtensionEnabled ? '75px' : '160px'}>
            <TagList
                vertical
                compact
                tagsVariant="basicSubtle"
                tags={pipe(
                    services,
                    array.map((s) => s.serviceName),
                    array.sort(string.Ord)
                )}
            />
        </Container>
    );
};
